import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const DropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    width: 100%;
    border: 1px solid ${colorsPalettes.carbon[50]};
`;
